import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { api, type SiteSettings } from "../lib/api";
import { canAccessAdmin } from "../lib/adminAccess";
import "./Layout.scss";

export function Layout() {
  const [site, setSite] = useState<SiteSettings | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    api.site().then(setSite).catch(() => setSite({ name: "jmartgraphix" }));
  }, []);

  // Only surface Admin when Traefik/Authelia already allows GET /admin
  useEffect(() => {
    let cancelled = false;
    canAccessAdmin().then((ok) => {
      if (!cancelled) setShowAdmin(ok);
    });
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const name = site?.name || "jmartgraphix";

  return (
    <>
      <header className="site-header">
        <div className="container site-header__inner">
          <Link to="/" className="site-header__logo" aria-label={`${name} home`}>
            <span className="site-header__logo-text">jmartgraphix</span>
          </Link>
          <button
            className="site-header__burger"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
          </button>
          <nav className={`site-header__nav ${menuOpen ? "is-open" : ""}`} aria-label="Main">
            <NavLink to="/portfolio">Portfolio</NavLink>
            <NavLink to="/resume">Resume</NavLink>
            <NavLink to="/about">About</NavLink>
            {showAdmin && (
              <NavLink to="/admin" className="site-header__admin">
                Admin
              </NavLink>
            )}
          </nav>
        </div>
      </header>
      <main className="site-main">
        <Outlet context={{ site }} />
      </main>
      <footer className="site-footer">
        <div className="container site-footer__inner">
          <div className="site-footer__brand">
            <img src="/logo.png" alt="" width={40} height={40} decoding="async" />
            <div>
              <strong>{name}</strong>
              <p>{site?.tagline || "Creative professional portfolio"}</p>
            </div>
          </div>
          <div className="site-footer__links">
            <a href={`mailto:${site?.social?.email || "jmartin@jmartgraphix.com"}`}>
              Contact
            </a>
            {site?.social?.youtube && (
              <a href={site.social.youtube} target="_blank" rel="noreferrer">
                YouTube
              </a>
            )}
            {site?.social?.vimeo && (
              <a href={site.social.vimeo} target="_blank" rel="noreferrer">
                Vimeo
              </a>
            )}
            {site?.social?.artstation && (
              <a href={site.social.artstation} target="_blank" rel="noreferrer">
                ArtStation
              </a>
            )}
            <Link to="/resume">Resume</Link>
          </div>
          <p className="site-footer__copy">© {new Date().getFullYear()} {name}</p>
        </div>
      </footer>
    </>
  );
}
